/**
 * Service for managing position-based component visibility
 */
export class PositionVisibilityService {
  private static instance: PositionVisibilityService;

  private constructor() {}

  public static getInstance(): PositionVisibilityService {
    if (!PositionVisibilityService.instance) {
      PositionVisibilityService.instance = new PositionVisibilityService();
    }
    return PositionVisibilityService.instance;
  }

  /**
   * Gets position ID from player assessment data
   * @param playerAssessment - The player assessment object with position
   * @returns The position ID
   */
  public getPositionId(playerAssessment: IPlayerAssessment): string {
    return playerAssessment.position?._id || '';
  }

  /**
   * Determines if a component should be shown based on supported positions and player position ID
   * @param supportedPositions - Array of position IDs that support this component (undefined means all positions)
   * @param playerPositionId - The player's current position ID
   * @returns boolean indicating if the component should be shown
   */
  public static shouldShowComponentForSupportedPositions(supportedPositions: string[] | undefined, playerPositionId: string): boolean {
    // If no positions specified, component is available for all positions
    if (!supportedPositions || supportedPositions.length === 0) {
      return true;
    }

    // Check if player's position ID is in the supported positions array
    return supportedPositions.includes(playerPositionId);
  }

  /**
   * Determines if a component should be hidden based on hidden positions and player position ID
   * @param hiddenPositions - Array of position IDs that should hide this component (undefined means no positions hidden)
   * @param playerPositionId - The player's current position ID
   * @returns boolean indicating if the component should be hidden
   */
  public static shouldHideComponentForPositions(hiddenPositions: string[] | undefined, playerPositionId: string): boolean {
    // If no hidden positions specified, component is not hidden
    if (!hiddenPositions || hiddenPositions.length === 0) {
      return false;
    }

    // Check if player's position ID is in the hidden positions array
    return hiddenPositions.includes(playerPositionId);
  }
}

// Export singleton instance
export const positionVisibilityService = PositionVisibilityService.getInstance();